export default __webpack_public_path__ + "media/images/map/marker_service_red-a5aa68123df93a152cb233104fbabaf7.png";